import { useCallback } from "react";
import { endOfMonth, endOfWeek, format, startOfMonth, startOfWeek } from "date-fns";

export default function useOACalendarFilters(applyFilterOverrides) {
	const resolveVisibleCalendarRange = useCallback((referenceDate) => {
		const monthStart = startOfMonth(referenceDate);
		const monthEnd = endOfMonth(referenceDate);

		return {
			date_start: format(startOfWeek(monthStart, { weekStartsOn: 1 }), "yyyy-MM-dd"),
			date_end: format(endOfWeek(monthEnd, { weekStartsOn: 1 }), "yyyy-MM-dd"),
		};
	}, []);

	const applyCalendarRange = useCallback(
		(referenceDate, extraOverrides = {}) => {
			if (typeof applyFilterOverrides !== "function") {
				return;
			}

			applyFilterOverrides({
				...resolveVisibleCalendarRange(referenceDate),
				...extraOverrides,
			});
		},
		[applyFilterOverrides, resolveVisibleCalendarRange],
	);

	const handleCalendarMonthChange = useCallback(
		(month) => {
			applyCalendarRange(month);
		},
		[applyCalendarRange],
	);

	return {
		applyCalendarRange,
		handleCalendarMonthChange,
	};
}
